import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"wave, waveform, signal, pulse, frequency"} maskId="square-filled-radius-0-stroke-1-IconWave"><path d="M12.5 20H16.5V11H22V12H17.5V21H11.5V4H7.5V12.5H2V11.5H6.5V3H12.5V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWave;
